import React from 'react';
import _ from 'lodash';

import {formValueSelector} from 'redux-form';

import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';
import {
  MODALS,
  fetchDepartureRoomChecks,
  fetchBookingSet,
  fetchDepositSummary,
  fetchRoomChecksTimeline
} from 'ducks/bookingSets';
import {closeModal, MODALS as BASE_MODALS} from 'ducks/modals';

import {AddDepartureRoomCheckForm} from './components';

import './styles.css';

class AddDepartureRoomCheckModal extends React.Component<any> {
  openModalForNextStep = () => {
    const {paymentTakenAtFrontDeskValue, selectedRoomValue} = this.props.data;

    const {tenancyId, bookingId} = selectedRoomValue;

    if (paymentTakenAtFrontDeskValue) {
      return this.props.openCreateChargeModal({
        tenancyId,
        bookingId
      });
    }

    return this.props.openConfirmAddDepartureRoomCheckModal();
  };

  getExtraActions = () => [
    ...this.props.closeModalExtraActions,
    () => closeModal(MODALS.ADD_DEPARTURE_ROOM_CHECK),
    () => closeModal(BASE_MODALS.ONE_OFF_CHARGE),
    () => closeModal(MODALS.CONFIRM_ADD_DEPARTURE_ROOM_CHECK),
    () =>
      fetchDepartureRoomChecks({bookingSetId: this.props.data.bookingSetId}),
    () => fetchBookingSet({bookingSetId: this.props.data.bookingSetId}),
    () => fetchDepositSummary({bookingSetId: this.props.data.bookingSetId}),
    () => fetchRoomChecksTimeline({bookingSetId: this.props.data.bookingSetId})
  ];

  render() {
    const {
      closeModal,
      data: {bookingSetId, selectedRoomValue, locationRef}
    } = this.props;

    return (
      <Modal
        className="AddDepartureRoomCheckModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={closeModal}>
        <Modal.Header heading="Add departure room check" />
        <Modal.Body>
          <AddDepartureRoomCheckForm
            bookingSetId={bookingSetId}
            locationRef={locationRef}
            storeDataExtraActions={this.props.storeDataExtraActions}
            getExtraActions={this.getExtraActions}
          />
        </Modal.Body>
        <Modal.Footer className="colab-row-space-between">
          <Button white className="cancel" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            className="add Button colab-bold blue"
            onClick={this.openModalForNextStep}
            disabled={_.isNil(selectedRoomValue)}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('addDepartureRoomCheckForm');

const mapStateToModalData = state => {
  const paymentTakenAtFrontDeskValue = formSelector(
    state,
    'paymentTakenAtFrontDesk'
  );

  return {
    paymentTakenAtFrontDeskValue,
    selectedRoomValue: formSelector(state, 'room')
  };
};

export default withModal(MODALS.ADD_DEPARTURE_ROOM_CHECK, mapStateToModalData)(
  AddDepartureRoomCheckModal
);
